import React from "react"
import CircularProgress from "material-ui/CircularProgress"
import EquipmentDetailsData from "./EquipmentDetailsData"
import EquipmentDetailsSummary from "./EquipmentDetailsSummary"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import EquipmentStore from "../../../stores/EquipmentStore"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import * as equipmentActions from "../../../actions/EquipmentActions"
import * as permissionHelper from "../../../helpers/permissionHelper"
import { IEquipmentDocument } from "../../../models"

interface IProps {
    params: { equipmentId: string, subpage: string }
}
interface IState {
    equipment: IEquipmentDocument
    loading: boolean
    editEquipment: boolean
    editEquipmentTimecard: boolean
}
const styles = {
    progress: {
        display: "flex",
        flex: "1 1 100%",
        placeContent: "center",
        height: "75vh",
        paddingTop: "12em"
    }
}

export default class EquipmentDetails extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            equipment: null,
            loading: true,
            editEquipment: permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.EditEquipment),
            editEquipmentTimecard: permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.EditTimecards)
        }
        autobind(this)
    }

    componentDidMount() {
        document.title = `${strings.Equipment} ${strings.Details} | ${strings.Findd_Grandd_Central}`
        equipmentActions.getEquipment(this.props.params.equipmentId, () =>
            this.setState({ loading: false })
        )
        EquipmentStore.on("equipment_change", this.onChangeEvent)
    }

    componentWillUnmount() {
        EquipmentStore.removeListener("equipment_change", this.onChangeEvent)
    }

    onChangeEvent() {
        this.setState({ equipment: EquipmentStore.getSelectedEquipment() })
    }

    render() {
        const { equipment, editEquipment, editEquipmentTimecard } = this.state
        const readonly = !editEquipment || (equipment && equipment.Deleted)
        const timecardReadonly = !editEquipmentTimecard || (equipment && equipment.Deleted)
        return (
            <div className="page-container EquipmentDetails">
                {this.state.loading ?
                    <div className="spinner" style={styles.progress}>
                        {" "}
                        <CircularProgress />{" "}
                    </div> :
                    <div className="user-details">
                        <EquipmentDetailsSummary
                            equipment={equipment}
                            readonly={readonly}
                        />
                        <EquipmentDetailsData
                            subpage={this.props.params.subpage}
                            equipmentId={this.props.params.equipmentId}
                            readonly={readonly}
                            timecardReadonly={timecardReadonly}
                        />
                    </div>
                }
            </div>
        )
    }
}
